import { createAction } from '@reduxjs/toolkit';

import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const uploadStandardTemplateRequest = payload =>
  actionRequestFactory(types.UPLOAD_STANDARD_TEMPLATE_REQUEST, payload);
export const uploadStandardTemplateSuccess = standardTemplate =>
  actionResponseFactory(types.UPLOAD_STANDARD_TEMPLATE_SUCCESS, { standardTemplate });
export const uploadStandardTemplateFailure = error =>
  actionResponseFactory(types.UPLOAD_STANDARD_TEMPLATE_FAILURE, { error });

export const getStandardTemplatesRequest = payload =>
  actionRequestFactory(types.GET_STANDARD_TEMPLATES_REQUEST, payload);
export const getStandardTemplatesSuccess = standardTemplates =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATES_SUCCESS, { standardTemplates });
export const getStandardTemplatesFailure = error =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATES_FAILURE, { error });

export const processStandardTemplatesRequest = payload =>
  actionRequestFactory(types.PROCESS_STANDARD_TEMPLATES_REQUEST, payload);
export const processStandardTemplatesSuccess = standardTemplates =>
  actionResponseFactory(types.PROCESS_STANDARD_TEMPLATES_SUCCESS, { standardTemplates });
export const processStandardTemplatesFailure = error =>
  actionResponseFactory(types.PROCESS_STANDARD_TEMPLATES_FAILURE, { error });

export const createStandardTemplateRequest = payload =>
  actionRequestFactory(types.CREATE_STANDARD_TEMPLATE_REQUEST, payload);
export const createStandardTemplateSuccess = standardTemplate =>
  actionResponseFactory(types.CREATE_STANDARD_TEMPLATE_SUCCESS, { standardTemplate });
export const createStandardTemplateFailure = error =>
  actionResponseFactory(types.CREATE_STANDARD_TEMPLATE_FAILURE, { error });

export const downloadStandardTemplateRequest = payload =>
  actionRequestFactory(types.DOWNLOAD_STANDARD_TEMPLATE_REQUEST, payload);
export const downloadStandardTemplateSuccess = standardTemplate =>
  actionResponseFactory(types.DOWNLOAD_STANDARD_TEMPLATE_SUCCESS, { standardTemplate });
export const downloadStandardTemplateFailure = error =>
  actionResponseFactory(types.DOWNLOAD_STANDARD_TEMPLATE_FAILURE, { error });

export const deleteStandardTemplateRequest = payload =>
  actionRequestFactory(types.DELETE_STANDARD_TEMPLATE_REQUEST, payload);
export const deleteStandardTemplateSuccess = standardTemplate =>
  actionResponseFactory(types.DELETE_STANDARD_TEMPLATE_SUCCESS, { standardTemplate });
export const deleteStandardTemplateFailure = error =>
  actionResponseFactory(types.DELETE_STANDARD_TEMPLATE_FAILURE, { error });

export const getStandardTemplateJobsRequest = payload =>
  actionRequestFactory(types.GET_STANDARD_TEMPLATE_JOBS_REQUEST, payload);
export const getStandardTemplateJobsSuccess = jobsData =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATE_JOBS_SUCCESS, { jobsData });
export const getStandardTemplateJobsFailure = error =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATE_JOBS_FAILURE, { error });

export const resetStandardTemplate = () =>
  actionRequestFactory(types.RESET_STANDARD_TEMPLATE, undefined);

export const getStandardTemplateAggregatesRequest = payload =>
  actionRequestFactory(types.GET_STANDARD_TEMPLATE_AGGREGATES_REQUEST, payload);
export const getStandardTemplateAggregatesSuccess = response =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATE_AGGREGATES_SUCCESS, response);
export const getStandardTemplateAggregatesFailure = error =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATE_AGGREGATES_FAILURE, { error });

export const getStandardTemplateEcslRequest = payload =>
  actionRequestFactory(types.GET_STANDARD_TEMPLATE_ECSL_REQUEST, payload);
export const getStandardTemplateEcslSuccess = response =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATE_ECSL_SUCCESS, response);
export const getStandardTemplateEcslFailure = error =>
  actionResponseFactory(types.GET_STANDARD_TEMPLATE_ECSL_FAILURE, { error });

export const saveManualAdjustments = payload =>
  actionRequestFactory(types.SAVE_MANUAL_ADJUSTMENTS, payload);
export const saveManualAdjustmentsSuccess = response =>
  actionResponseFactory(types.SAVE_MANUAL_ADJUSTMENTS_SUCCESS, response);
export const saveManualAdjustmentsFailure = error =>
  actionResponseFactory(types.SAVE_MANUAL_ADJUSTMENTS_FAILURE, { error });

export const getPreviousFilingData = payload =>
  actionRequestFactory(types.GET_PREVIOUS_FILING_DATA_REQUEST, payload);
export const getPreviousFilingDataSuccess = () =>
  actionRequestFactory(types.GET_PREVIOUS_FILING_DATA_SUCCESS, null);
export const getPreviousFilingDataFailure = () =>
  actionRequestFactory(types.GET_PREVIOUS_FILING_DATA_FAILURE, null);

export const fetchProcessingAggregatesStart = createAction(types.FETCH_PROCESSING_AGGREGATES_START);
export const fetchProcessingAggregatesStop = createAction(types.FETCH_PROCESSING_AGGREGATES_STOP);
export const fetchProcessingAggregatesRequest = createAction(
  types.FETCH_PROCESSING_AGGREGATES_REQUEST
);
export const fetchProcessingAggregatesSuccess = createAction(
  types.FETCH_PROCESSING_AGGREGATES_SUCCESS
);
